import { AntDatePicker, FormGroup, FormGroupProps } from '@agro-club/agroclub-shared'
import { ShortFormControl } from 'views/styled/common'
import { ComponentProps, FC, ReactNode } from 'react'
import { AAntDatePicker } from '../Analytics'
import { FormikFieldsType } from 'modules/domain/types'

type DatePiketProps = ComponentProps<typeof AntDatePicker>

type Props = {
  formik: FormikFieldsType
  label: ReactNode
  fieldName: string
  id: string
  required?: boolean
  size?: DatePiketProps['size']
  labelWidth?: FormGroupProps['labelWidth']
  short?: boolean
}

export const FormDatePicker: FC<Props> = ({
  formik,
  label,
  fieldName,
  id,
  required,
  size,
  labelWidth,
  short = true,
}) => {
  const controls = (
    <FormGroup
      label={label}
      error={formik.errors[fieldName]}
      required={required}
      labelWidth={labelWidth}
      labelHeight={size}
    >
      <AAntDatePicker
        onChange={(value) => formik.setFieldValue(fieldName, value['date'])}
        size={size}
        error={!!formik.errors[fieldName]}
        value={formik.values[fieldName]}
        allowClear
        id={id}
      />
    </FormGroup>
  )
  if (short) {
    return <ShortFormControl>{controls} </ShortFormControl>
  }
  return controls
}
